<template>
    <div class="lcu-confirm-wrapper" id="parent">
        <transition name="notification" appear>
            <div
              v-show="isShowing"
              class="lcu-confirm-markConfirm"
              id="child"
              @click.stop>
                <span class="lcu-confirm-markMsg">
                    {{ message }}
                </span>
                <button
                  @click.prevent="onCancel"
                  class="lcu-confirm-btnCancel"
                  name="cancel-mark-user">
                  Cancelar
                </button>
                <button
                  class="lcu-confirm-btn"
                  @click.prevent="onConfirm"
                  name="yes-mark-user">
                  Sí
                </button>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
  name: 'confirm-slider',
  props: {
    message: {
      type: String,
      default: '¿Estás seguro?',
    },
    type: {
      type: String,
      default: '',
    },
    onConfirm: {
      type: Function,
      required: true,
      default: () => {},
    },
    onCancel: {
      type: Function,
      required: true,
      default: () => {},
    },
    isShowing: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-confirm-wrapper {
  position: relative;

  &:after {
    clear: both;
    content: '';
    display: table;
  }

  &:before {
    clear: both;
    content: '';
    display: table;
  }
}

.lcu-confirm-markMsg {
  align-items: center;
  display: flex;
  font-size: 13px;
}

.lcu-confirm-btn {
  background-color: rgba($white, .8);
  border: 0;
  color: $danger;
  padding: 5px 10px;

  &:hover {
    cursor: pointer;
  }
}

.lcu-confirm-btnCancel {
  background-color: transparent;
  border: 0;
  border-radius: 3px;
  color: rgba($white, .8);
  padding: 5px 12px;

  &:hover {
    cursor: pointer;
  }
}

.lcu-confirm-markConfirm {
  background-color: $danger;
  border-radius: 2px;
  color: $white;
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 1fr max-content max-content;
  min-width: 100%;
  padding: 10px;
  position: absolute;
  right: 0;
  text-align: left;
  z-index: 3;

  @media only screen and (max-width: $mobile-max) {
    bottom: 15px;
  }

  &:hover {
    cursor: default;
  }
}

.notification-enter-active {
  animation: notificationSlide-in 0.4s;
}

.notification-leave-active {
  animation: notificationSlide-out 0.4s;
}

@keyframes notificationSlide-in {
  0% {
    opacity: 0;
    min-width: 30%;
  }

  100% {
    opacity: 1;
    min-width: 100%;
  }
}

@keyframes notificationSlide-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
